import debounce from "../../resources/js/helpers/debounce";
class PieChart {
  constructor({
                section,
                doughnutHoleSize = 0.55,
              } = {}) {
    if (!section) return;
    this.section = section;
    this.canvas = section.querySelector('canvas');
    if (doughnutHoleSize) this.doughnutHoleSize = doughnutHoleSize;
    this.ctx = this.canvas.getContext("2d");
    this.pieData = [];
    this.hoverValue = 0;
    this.allItems = [...section.querySelectorAll('.tji-circle-diagram__diagram-item')]; // li items
    this.allPopups = [...section.querySelectorAll('.tji-circle-diagram__popup')];
    this.data = this.allItems.map(element => ({label: element.dataset.title, value: parseInt(element.dataset.percentages), color: element.dataset.color, element, id: element.dataset.li}));
    this.totalValue = [...Object.values(this.data)].reduce((a, b) => a + b.value, 0);
    this.visiblePopup = null;
    this.liInFocus = null;
  }
  drawPieSlice(ctx, centerX, centerY, radius, startAngle, endAngle, fillColor, strokeColor) {
    ctx.save();
    ctx.fillStyle = fillColor;
    ctx.strokeStyle = strokeColor;
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.arc(centerX, centerY, radius, startAngle, endAngle);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();
  }

  drawArc(ctx, centerX, centerY, radius, startAngle, endAngle, color) {
    ctx.save();
    ctx.strokeStyle = color;
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, startAngle, endAngle);
    ctx.stroke();
    ctx.restore();
  }

  drawSlices(radius) {
    let startAngle = -Math.PI / 2;
    for (const obj of this.data) {
      const sliceAngle = (2 * Math.PI * obj.value) / this.totalValue;

      this.pieData.push({
        percentages: obj.value,
        startAngle : startAngle,
        endAngle : startAngle + sliceAngle,
        id : obj.id,
      })

      this.drawPieSlice(
        this.ctx,
        this.canvas.width / 2,
        this.canvas.height / 2,
        radius,
        startAngle,
        startAngle + sliceAngle,
        obj.color,
        obj.color,
      );

      startAngle += sliceAngle;
    }

    if (this.doughnutHoleSize) {
      this.drawPieSlice(
        this.ctx,
        this.canvas.width / 2,
        this.canvas.height / 2,
        this.doughnutHoleSize * radius,
        0,
        2 * Math.PI,
        "#FFF",
        "#FFF"
      );

      this.drawArc(
        this.ctx,
        this.canvas.width / 2,
        this.canvas.height / 2,
        this.doughnutHoleSize * radius,
        0,
        2 * Math.PI,
        "#FFF",
      );
    }
  }

  handleFocus(target) {
    const inFocus = this.allItems.find(li => li === target);
    if (inFocus) this.liInFocus = inFocus;
  }

  handleHover(e) {
    // It was inside the pie chart?
    const xFromCenter = e.clientX - e.target.getBoundingClientRect().left - this.canvas.width / 2;
    const yFromCenter = e.clientY - e.target.getBoundingClientRect().top - this.canvas.height / 2;
    const distanceFromCenter = Math.sqrt(Math.pow(Math.abs(xFromCenter), 2) + Math.pow(Math.abs(yFromCenter), 2));
    let circleRadius = '';
    if (this.canvas.width === 600) {
      circleRadius = Math.min(this.canvas.width, this.canvas.height) / 2 - 120;
    } else {
      circleRadius = Math.min(this.canvas.width, this.canvas.height) / 2;
    }
    if (distanceFromCenter <= circleRadius) {
      // Cursor position inside the chart.
      let hoverAngle = Math.atan2(yFromCenter, xFromCenter);
      // Added because of Pie rotated relative to the default value
      if (xFromCenter < 0 && yFromCenter < 0) hoverAngle = 2 * Math.PI + hoverAngle;
      const li = this.pieData.find(entry => hoverAngle >= entry.startAngle && hoverAngle <= entry.endAngle);

      if (li) {
        const popUpToShow = this.allPopups.find(popup => popup.dataset.popup === li.id);
        if (popUpToShow) {
          this.visiblePopup &&  this.visiblePopup.classList.remove('visible');
          this.visiblePopup = popUpToShow;
          popUpToShow.classList.add('visible');
        }
      }
    } else {
      // Cursor position is not inside the chart.
      // Remove visible popup.
      if (this.visiblePopup) this.visiblePopup.classList.remove('visible');
      this.hoverValue = 0;
      this.visiblePopup = null;
    }
  }

  removeVisibleElement(e) {
    if (this.visiblePopup) {
      //This transparent element helps not to hide popup when cursor position on popup
      const fullElement = this.visiblePopup.querySelector('.tji-circle-diagram__popup-full');
      if (e.target !== this.canvas && e.target !== fullElement) {
        if (fullElement) this.visiblePopup.classList.remove('visible');
        this.visiblePopup = null;
        this.hoverValue = 0;
      }
    }
  }

  drawLabels(radius) {
    let startAngle = -Math.PI / 2;
    for (const obj of this.data) {
      const sliceAngle = (2 * Math.PI * obj.value) / this.totalValue;
      const labelX =
        this.canvas.width / 2 +
        (radius + 60) * Math.cos(startAngle + sliceAngle / 2);
      const labelY =
        this.canvas.height / 2 +
        (radius + 60) * Math.sin(startAngle + sliceAngle / 2);

      const offsetX = obj.element.dataset.offsetX ? parseInt(obj.element.dataset.offsetX) : 0;
      const offsetY = obj.element.dataset.offsetY ? parseInt(obj.element.dataset.offsetY) : 0;

      obj.element.style.left = labelX + offsetX + 'px';
      obj.element.style.top = labelY + offsetY + 'px';

      startAngle += sliceAngle;
    }
  }

  draw() {
    if (window.innerWidth < 640 && window.innerWidth > 425) {
      this.canvas.width = 360;
      this.canvas.height = 360;
      this.drawSlices(Math.min(this.canvas.width / 2, this.canvas.height / 2));
    } else if (window.innerWidth <= 425) {
      this.canvas.width = 290;
      this.canvas.height = 290;
      this.drawSlices(Math.min(this.canvas.width / 2, this.canvas.height / 2));
    } else {
      this.canvas.width = 600;
      this.canvas.height = 600;
      const radius = Math.min(this.canvas.width / 2, this.canvas.height / 2) - 120;
      this.drawSlices(radius);
      this.drawLabels(radius);
    }
  }

  openPopup() {
    if (this.liInFocus) {
      const popup = this.allPopups.find(popup => popup.dataset.popup === this.liInFocus.dataset.li);
      if (!popup) return;
      popup.classList.add('visible');
      popup.focus();
      this.visiblePopup = popup;
    }
  }

  closePopup(next = true) {
    if (!this.visiblePopup) return;
    this.visiblePopup.classList.remove('visible');
    const prevLiIndex = this.allItems.findIndex(item => item === this.liInFocus);
    this.allItems[next ? prevLiIndex + 1 : prevLiIndex].focus();
    this.visiblePopup =  null;
  }

  displayPopupHandler(e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      // toggle
      this.liInFocus && !this.visiblePopup ? this.openPopup() : this.closePopup();
    } else if (e.key === 'Tab') {
      // close popup
      this.closePopup(e.shiftKey);
    }
  }

  initListeners() {
    this.section.addEventListener('mousemove', (e) => this.removeVisibleElement(e));
    window.addEventListener("resize", debounce(()=> this.draw()));
    this.canvas.addEventListener('mousemove', (e) => this.handleHover(e));
    this.section.addEventListener('focus', (e)=> this.handleFocus(e.target), true);
    this.section.addEventListener("keydown", (e) => this.displayPopupHandler(e));
  }
}

window.addEventListener("DOMContentLoaded", ()=> {
  const sections = document.querySelectorAll('.tji-circle-diagram__diagram-wrapper');
  if (sections.length > 0) sections.forEach(section => {
    const pieChart = new PieChart({
      section,
    })
    pieChart.draw();
    pieChart.initListeners();
  })
});
